import { render, staticRenderFns } from "./CustomFormBuilder.vue?vue&type=template&id=f16bace2&scoped=true"
import script from "./CustomFormBuilder.vue?vue&type=script&lang=js"
export * from "./CustomFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./CustomFormBuilder.vue?vue&type=style&index=0&id=f16bace2&prod&lang=css"
import style1 from "./CustomFormBuilder.vue?vue&type=style&index=1&id=f16bace2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16bace2",
  null
  
)

export default component.exports